import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Plus } from 'lucide-react';
import { getMyPaymentMethods, deletePaymentMethod } from '../../services/p2pService';
import { useToast } from '../../context/ToastContext';

function maskAccount(val: string): string {
    if (!val) return '';
    if (val.length <= 4) return val;
    return '****' + val.slice(-4);
}

export default function PaymentMethods() {
    const navigate = useNavigate();
    const { toast } = useToast();
    const [methods, setMethods] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const load = () => {
        setLoading(true);
        getMyPaymentMethods().then(setMethods).catch(() => {}).finally(() => setLoading(false));
    };
    useEffect(() => { load(); }, []);

    const handleDelete = async (id: string) => {
        try {
            await deletePaymentMethod(id);
            toast('Removed', 'success');
            load();
        } catch (e: any) { toast(e.message, 'error'); }
    };

    return (
        <div style={{ background: 'var(--p2p-bg-primary)', minHeight: '100vh' }}>
            <div className="p2p-header">
                <button className="p2p-back-btn" onClick={() => navigate(-1)}>
                    <ArrowLeft size={20} />Payment Methods
                </button>
            </div>

            {loading ? (
                <div className="p2p-loading"><div className="p2p-spinner" /></div>
            ) : (
                <div style={{ padding: 16 }}>
                    {methods.length === 0 && (
                        <div className="p2p-empty">
                            <p className="p2p-empty-text">No payment methods added</p>
                        </div>
                    )}
                    {methods.map(m => (
                        <div key={m._id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 0', borderBottom: '1px solid var(--p2p-border-default)' }}>
                            <span className="p2p-pm-dot" style={{ background: m.methodColor, width: 10, height: 10 }} />
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--p2p-text-primary)' }}>{m.methodType}</div>
                                <div style={{ fontSize: 12, color: 'var(--p2p-text-muted)', marginTop: 2 }}>
                                    {m.accountName}
                                    {m.accountNumber ? ` · ${maskAccount(m.accountNumber)}` : ''}
                                    {m.phoneNumber ? ` · ${maskAccount(m.phoneNumber)}` : ''}
                                </div>
                            </div>
                            <button
                                onClick={() => handleDelete(m._id)}
                                style={{ background: 'none', border: 'none', color: 'var(--p2p-sell)', cursor: 'pointer', fontSize: 13, padding: '4px 8px' }}
                            >
                                Remove
                            </button>
                        </div>
                    ))}

                    <button
                        className="p2p-btn-yellow"
                        style={{ marginTop: 24 }}
                        onClick={() => navigate('/p2p/payment-methods/add')}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                            <Plus size={18} />Add a payment method
                        </span>
                    </button>
                </div>
            )}
        </div>
    );
}
